import { z } from 'zod';

export const dealerKitRegistrationTypeSchema = z.enum(['lead', 'stock', 'dealer']);

export type DealerKitRegistrationType = z.infer<typeof dealerKitRegistrationTypeSchema>;

export const dealerKitRegistrationSchema = z.object({
  id: z.string().uuid(),
  type: dealerKitRegistrationTypeSchema,
  dealerkit_id: z.number().int(),
  endpoint: z.string().url(),
  enabled: z.boolean(),
  workflow_id: z.string().uuid().nullable(),
  workflow_name: z.string().optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type DealerKitRegistration = z.infer<typeof dealerKitRegistrationSchema>;

export const createDealerKitRegistrationSchema = z.object({
  type: dealerKitRegistrationTypeSchema,
  workflow_id: z.string().uuid().nullable(),
});

export type CreateDealerKitRegistrationDto = z.infer<typeof createDealerKitRegistrationSchema>;

export const updateDealerKitRegistrationSchema = z.object({
  enabled: z.boolean().optional(),
  workflow_id: z.string().uuid().nullable().optional(),
});

export type UpdateDealerKitRegistrationDto = z.infer<typeof updateDealerKitRegistrationSchema>;

export const dealerKitWebhookLogStatusSchema = z.enum(['RECEIVED', 'PROCESSED', 'FAILED']);

export const dealerKitWebhookLogSchema = z.object({
  id: z.string().uuid(),
  registration_id: z.string().uuid(),
  contact_id: z.string().uuid().nullable(),
  payload: z.record(z.string(), z.unknown()),
  workflow_executed: z.boolean(),
  status: dealerKitWebhookLogStatusSchema,
  error_message: z.string().nullable(),
  created_at: z.string().datetime(),
});

export type DealerKitWebhookLog = z.infer<typeof dealerKitWebhookLogSchema>;

export const paginatedDealerKitWebhookLogsSchema = z.object({
  data: z.array(dealerKitWebhookLogSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});

export type PaginatedDealerKitWebhookLogs = z.infer<typeof paginatedDealerKitWebhookLogsSchema>;

export const paginatedDealerKitContactsSchema = z.object({
  data: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      phone: z.string().nullable(),
      email: z.string().nullable(),
      data: z.record(z.string(), z.unknown()).nullable(),
      created_at: z.string().datetime(),
      updated_at: z.string().datetime(),
    }),
  ),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});

export type PaginatedDealerKitContacts = z.infer<typeof paginatedDealerKitContactsSchema>;
